<template>
  <div
    :class="[
      'dialog-mask-default',
      visible && 'dialog-mask-visible',
      tiny == false && 'dialog-mask-force'
    ]"
  >
    <div :class="[tiny ? 'dialog-container-tiny' : 'dialog-container']">
      <div class="container-header">
        <div class="tiny-header">
          <div :class="['icon-group', !tiny && 'icon-group-hide']">
            <span class="icon-broadcast"></span>
            <span>{{ msgType }}</span>
          </div>
          <span class="icon-close" @click="bindDialogCloseEvent('done')"></span>
        </div>
        <span
          :class="[
            'clickable-hint',
            'dialog-title',
            tiny && 'dialog-title-tiny'
          ]"
          >{{ title }}</span
        >
        <span class="create-time" :hidden="tiny">{{ createTime }}</span>
      </div>
      <div class="solt-container">
        <div v-html="transHtml(content)"></div>
      </div>
      <div :class="['dialog-options', tiny && 'dialog-options-flex-end']">
        <button class="btn" @click="bindDialogCloseEvent('done')">
          {{ type == 4 ? '稍后处理' : iknowTxt }}
        </button>
        <button class="btn btn-detail" @click="bindDialogCloseEvent('more')">
          {{ type ==4 ? '马上处理' : openTxt }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "notificationDialog",
  data() {
    return {
      visible: false,
      msgType: "系统通知",
      iknowTxt: "我知道了",
      openTxt: "查看详情"
    };
  },
  props: {
    /**唯一消息id  */
    msgId: {
      type: String,
      default: "",
      required: false
    },
    /** 是否轻量化通知 位于右下角 没有遮罩层 */
    tiny: {
      type: Boolean,
      default: false
    },
    /** 通知标题 */
    title: {
      type: String,
      default: "默认标题",
      required: true
    },
    /** 创建时间 对强弹窗有效 */
    createTime: {
      type: String,
      default: "默认时间",
      required: true
    },
    /** 通知内容 支持富文本显示 */
    content: {
      type: String,
      default: "默认内容",
      required: false
    },
    /** 通知类型 4 为采购需求退回通知 */
    type: {
      type: Number,
      required: false
    }

  },
  methods: {
    /** 绑定弹窗操作事件 */
    bindDialogCloseEvent(EnentName) {
      this.$emit(EnentName);
    },
    transHtml(str) {
      return str
        .replace(str ? /&(?!#?\w+;)/g : /&/g, "&amp;")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&amp;nbsp;/g, "\u3000");
    }
  }
};
</script>

<style lang="scss" scoped>
@mixin bgicon($url) {
  background-image: url($url);
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}

.dialog-mask-default {
  opacity: 0;
  height: 0;
  transition: ease-in-out 0.1s;
}

.dialog-mask-force {
  height: 100vh;
  width: 100vw;
  position: fixed;
  left: 0;
  top: 0;
  background-color: #0000009d;
  transition: ease-in-out 0.1s;
  z-index: -1;
}

.dialog-mask-visible {
  opacity: 1;
  z-index: 9999;
  transition: ease-in-out 0.1s;
}

.dialog-container {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  height: fit-content;
  width: fit-content;
  min-width: 500px;
  max-height: 580px;
  max-width: 580px;
  padding: 16px 22px;
  border-radius: 8px;
  z-index: 1001;
  display: flex;
  flex-direction: column;
  transform: translate(0, -30px);
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  background: url("~@/components/notificationBar/assets/componentBgImg.png")
    rgb(255, 255, 255) 50% / cover no-repeat;
}

.dialog-container-tiny {
  position: fixed;
  right: 26px;
  bottom: 26px;
  height: fit-content;
  width: 505px;
  padding: 16px 22px;
  border-radius: 8px;
  z-index: 1001;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.113);
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  background: url("~@/components/notificationBar/assets/componentBgImg.png")
    rgb(255, 255, 255) 50% / cover no-repeat;

  &:hover {
    transition: ease-in-out 0.1s;
    transform: translate(-2px, -2px);
  }
}

.dialog-container,
.dialog-container-tiny {
  .container-header {
    padding-bottom: 12px;
    display: flex;
    font-size: 16px;
    flex-direction: column;

    .tiny-header {
      display: flex;
      justify-content: space-between;
    }

    .icon-group {
      display: flex;
    }

    .icon-group-hide {
      opacity: 0;
    }

    .icon-close {
      display: inline-block;
      width: 18px;
      height: 18px;
      @include bgicon("~@/components/notificationBar/assets/icon-close.png");
      cursor: pointer;
      align-self: center;
    }

    .icon-broadcast {
      display: inline-block;
      width: 24px;
      height: 24px;
      @include bgicon(
        "~@/components/notificationBar/assets/icon-broadcast.png"
      );
      margin-right: 8px;
    }

    .dialog-title {
      font-size: 20px;
      font-weight: 700;
      text-align: center;
    }

    .dialog-title-tiny {
      text-align: left;
      padding-top: 31px;
    }

    .create-time {
      color: #000;
      font-size: 14px;
      opacity: 0.7;
      margin-top: 14px;
      text-align: center;
    }
  }

  .solt-container {
    overflow-y: auto;
    mix-blend-mode: multiply;

    >>> img {
      max-width: 100%;
      height: auto;
    }
  }

  .solt-container::-webkit-scrollbar {
    width: 6px;
  }

  .solt-container::-webkit-scrollbar-thumb {
    background: #cccccc;
    border-radius: 12px;
  }

  .dialog-options {
    display: flex;
    justify-content: center;
    margin-top: 85px;

    .btn {
      width: fit-content;
      padding: 5px 10px;
      font-size: 12px;
      line-height: 18px;
      cursor: pointer;
      border-radius: 2px;
      border: 1px solid #dbdbdb;
      background-color: #fff;
      color: #000;
    }

    .btn-detail {
      margin-left: 16px;
      color: #ffffff;
      background-color: #005bac;
      border: 1px #005bac;
    }
  }

  .dialog-options-flex-end {
    justify-content: flex-end;
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/notificationBar/dialog.vue